<script>
import LoginForm from "../../molecules/Login/LoginForm.vue";
import LoginWelcome from "../../molecules/AuthWelcome.vue";
import LoginCandidates from "../../molecules/FoundCandidates.vue";
import LoginCandidateWide from "../../atoms/Login/LoginCandidateWide.vue";
import RecentLogins from "../../molecules/Login/RecentLogins.vue";
import RecentLoginDivider from "../../atoms/Divider.vue";
import ForgotPasswordForm from "../../molecules/Forgot/ForgotPasswordForm.vue";
import BasicButton from "../../../../theme/atoms/BasicButton.vue";
import FoundCandidates from "../../molecules/FoundCandidates.vue";

export default {
    name: "ForgotPasswordCard",
    components: {
        FoundCandidates,
        ForgotPasswordForm,
        BasicButton, LoginWelcome, LoginForm},
    props: {
        candidates: {
            type: Array,
            required: false,
        },
        successMessage: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        }

    },
    computed: {
        hasCandidates() {
            return this.candidates && this.candidates.length > 0;
        },
    }
}
</script>

<template>
    <div>
        <div class="card py-5 px-lg-4 d-flex flex-row login-card transparent-card" v-if="!hasCandidates">
            <div class="w-100 d-none d-lg-block position-relative">
                <login-welcome/>
                <div class="px-5 position-absolute bottom-0 w-100">
                    <basic-button class="btn-outline" href="/auth" icon="fi-rr-arrow-small-left" icon-position="left"
                                  type="button" :text="trans('general.page.forgot_password.back')" />
                </div>
            </div>

            <div class="form d-flex flex-column justify-content-center w-100 px-xl-5">
                <div class="d-flex flex-column gap-2 w-100 px-md-4 px-xl-0">
                    <div class="mb-4 d-flex flex-column align-items-center align-items-md-start">
                        <img alt="Logo" class="d-lg-none mb-4" src="/img/logo.svg" width="200">

                        <h1>{{ trans('general.page.forgot_password.title') }}</h1>
                        <p class="label mb-0">{{ trans('general.page.forgot_password.description') }}</p>
                    </div>

                    <forgot-password-form v-on="$listeners" :errors="errors" :message="successMessage"/>

                    <div class="text-center">
                        <basic-button class="btn-link text-decoration-none d-lg-none" href="/auth" icon="fi-rr-arrow-small-left" icon-position="left"
                                      type="button" :text="trans('general.page.forgot_password.back')" />
                    </div>
                </div>
            </div>
        </div>
        <div class="card py-5 px-lg-4 d-flex flex-row login-card" v-else>
            <found-candidates :candidates="candidates" v-on="$listeners" />
        </div>
    </div>
</template>

<style scoped>
@media (max-width: 768px) {
    .transparent-card {
        background-color: transparent;
    }
}
</style>
